// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"247":"54ef7ca2","959":"54ef7ca2"}[chunkId] + ".chunk.css";
};